
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { namespace } from 'vuex-class';
import Multiselect from 'vue-multiselect';

import { Guard, GuardType } from '@/store/dispatch/types';
import GuardTypeSelector from '@/components/dispatch/GuardTypeSelector.vue';

const Dispatch = namespace('dispatch');

@Component({
  components: {
    'multiselect': Multiselect,
    GuardTypeSelector
  }
})
export default class AddNewGuard extends Vue {
  public hasValidationErrors: boolean = false;
  public showErrorAnimation: boolean = false;
  
  @Dispatch.Getter('getGuardTypes') guardTypes!: GuardType[];
  @Dispatch.Action loadGuardTypes: any;
  @Dispatch.Action updateGuard: any;

  @Prop({
    default: () => ({
      callsign: {
        type: String,
        required: true
      }
    })    
  })

  newGuard!: Guard;

  @Watch("newGuard.callsign")
  onCallsignChanged(callsign: string) {
    this.hasValidationErrors = !callsign.length;
  }

  public isValid() {
    return !!this.newGuard.callsign.length;
  }

  mounted() {
    this.loadGuardTypes();
  }

  public onSave() {
    if (this.isValid()) {
      this.hasValidationErrors = false;
      this.$emit("save", this.newGuard);
    } else {
      this.hasValidationErrors = true;
      this.showErrorAnimation = true;

      setTimeout(() => {
        this.showErrorAnimation = false;
      }, this.$config.ANIMATION_DURATION);
    }
  }

  public onCancel() {
    this.$emit("cancel");
  }
}
